// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"6":"token","50":"match","83":"train","229":"config","966":"login"}[chunkId] || chunkId) + "." + {"6":"fd9c89a4","50":"b2e3d069","83":"e9468042","229":"959da470","300":"eaa7b593","721":"7f6bc493","966":"01b86610"}[chunkId] + ".js";
};